<template>
    <div>
        <homen></homen>
        <div class="pagerc">
            <div class="headerimg">
                <img class="pcshow" src="../assets/images/spon.jpg" alt="">
                <img class="mshow" src="../assets/images/mspon.png" alt="">
                <div class="title">
                    <div class="titlep">
                        <h3>SPONSORSHIP</h3>
                        <h4>赞助参展</h4>
                    </div>
                </div>
            </div>
            <div class="inchild clear">
                <div class="wrapleft">
                    <div class="mspon mshow">
                        <h6>Organizer</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="../assets/images/logobk.svg" alt=""></a></li>
                        </ul>
                        <h6>Co-organizer</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="http://static.hrflag.com/img/spon/ddi-logo.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="http://hrflag.com/img/zqlogogr.svg" alt=""></a></li>
                        </ul>
                        <h6>Academic Institutional Support</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="http://edm.hrflag.com/imgs/lalogo.jpg" alt=""></a></li>
                        </ul>
                        <h6>Intellectual Support</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="../assets/images/cho100.png" alt=""></a></li>
                        </ul>
                        <h6>Note Support</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="../assets/images/biji.svg" alt=""></a></li>
                        </ul>
                        <h6>Media Support</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="http://static.hrflag.com/logo/pxzz.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="../assets/images/GHRlogo.jpg" alt=""></a></li>
                        </ul>
                        <h6>Sponsors</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="../assets/images/weir.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="../assets/images/cubiks.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="../assets/images/gml.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="../assets/images/liepin.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="../assets/images/sea.png" alt=""></a></li>
                            <li><a href="javascript:;"></a></li>
                        </ul>
                    </div>
                    <h2>Diversified Sponsorship Solutions</h2>
                    <div class="sponbox">
                        <div class="sponqy">
                            <h6>PRICE OF STANDARD BOOTH SPONSORSHIP 60,000RMB</h6>
                            <ul>
                                <li>The name and logo of the company will be displayed on the official website of the summit for brand promotion</li>
                                <li>The company logo will be displayed on the main background panel of the summit for brand promotion</li>
                                <li>The company's promotional video will be played in a loop on the LED display screen (40-inch) on the site</li>
                                <li>2 free tickets for staff (including meals, valued at RMB 10,400)</li>
                                <li>Get a standard exhibition booth on the site</li>
                                <li>Enjoy a 10% discount on tickets for employees</li>
                                <li>One copy of company materials (within 10P) put in the information kit</li>
                                <li>1P four-color advertisement in the journal</li>
                            </ul>
                        </div>
                        <div class="sponqy">
                            <h6>PRICE OF TEA BREAK SPONSORSHIP 40,000RMB</h6>
                            <ul>
                                <li>The name and logo of the company will be displayed on the official website of the summit for brand promotion</li>
                                <li>The company logo will be displayed on the main background panel of the summit for brand promotion</li>
                                <li>A tripod with the company logo will be displayed in the tea break area and the tea drink area during tea breaks</li>
                            </ul>
                        </div>
                    </div>
                    <div class="sponbox">
                        <div class="sponqy">
                            <h6>PRICE OF GIFT SPONSORSHIP 30,000RMB</h6>
                            <ul>
                                <li>The name and logo of the company will be displayed on the official website of the summit for brand promotion</li>
                                <li>The company logo will be displayed on the main background panel of the summit for brand promotion</li>
                                <li>The company's logo and the conference's logo will be displayed on the gifts</li>
                            </ul>
                        </div>
                        <div class="sponqy">
                            <h6>PRICE OF BOOK OR MAGAZINE EXHIBITION SPONSORSHIP 10,000 RMB /BOOK</h6>
                            <ul>
                                <li>The name and logo of the company will be displayed on the official website of the summit for brand promotion</li>
                                <li>The company logo will be displayed on the main background panel of the summit for brand promotion</li>
                                <li>On-site display of assessment books and display of company logo</li>
                                <li>Exhibited books will be publicized and promoted through e-mails</li>
                                <li>Participants can buy exhibited books on the spot</li>
                                <li>The company can arrange a small scale book signing session (the number of books should not exceed 50)</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <wrapright></wrapright>
            </div>
        </div>
        <foot></foot>
    </div>
</template>

<script>
import homen from '@/components/commn/homen'
import foot from '@/components/commn/foot'
import wrapright from '@/components/commn/wrapright'
 export default {
      components:{
        homen,
        foot,
        wrapright
      },
         metaInfo: {
            title: 'Sponsorship - 42nd International Congress on Assessment Center Methods and Developing Leadership Talent',
            meta: [
            {
                name: 'keywords',
                content: '42nd International Congress on Assessment Center Methods and Developing Leadership Talent; Leadership Development Forum'
            },
            {
                name: 'description',
                content: '42nd International Congress On Assessment Center Methods And Developing Leadership Talent offer the multi-sponsorship solution, including standard booth sponsorship, tea break sponsorship, gift sponsorship, book or magazine exhibition sponsorship'
            }
            ]
        },
}
</script>

<style scoped>
 @import url('../assets/css/inpublic.css');
    .sponbox  .sponqy {
        width: 550px;
        height: 500px;
        border: solid 10px #f0f0f0;
        background: #ffffff;
    }
    @media screen and (max-width:768px) {
       .sponbox .sponqy {
            width: 100%;
            height: auto;
        }
         .wrapright {
            display: block !important;
            width: 50%;
            margin: 0 auto;
            float: none !important;
            margin-top: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/spon_en.vue